import { render, staticRenderFns } from "./gamesRounds.vue?vue&type=template&id=36a1bc86&scoped=true"
import script from "./gamesRounds.vue?vue&type=script&lang=js"
export * from "./gamesRounds.vue?vue&type=script&lang=js"
import style0 from "./gamesRounds.vue?vue&type=style&index=0&id=36a1bc86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a1bc86",
  null
  
)

export default component.exports